export const ORGANIZATION_TYPE_STORE = 'ORGANIZATION_TYPE_STORE';
export const ORGANIZATION_TYPE_UPDATE = 'ORGANIZATION_TYPE_UPDATE';
export const ORGANIZATION_TYPE_DESTROY = 'ORGANIZATION_TYPE_DESTROY';
